import NiceSelect from "nice-select2/src/js/nice-select2";

export default function Select() {
    return {
        init() {
            let selects = document.querySelectorAll('.gfield_select');
            if (selects.length > 0) {
                selects.forEach((select) => {
                    new NiceSelect(select);
                });
            }
        }
    }
}